var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 37.594,
    viewBox: "0 0 38 37.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M100,167.594h0a18.964,18.964,0,0,0-19-18.75,18.952,18.952,0,0,0,13.429-5.526A18.639,18.639,0,0,0,100,130a18.641,18.641,0,0,0,5.571,13.319A18.95,18.95,0,0,0,119,148.844,18.965,18.965,0,0,0,100,167.594Z",
    transform: "translate(-81 -130)",
    fill: "#2c2c2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.49f32ceaa6bdfe2e1c46f99007eaf944.svg";
export { ForwardRef as ReactComponent };